import React from 'react';
import ItemSelector from 'shared/ui/ItemSelector';
import List from 'shared/ui/List';
import SnapItem from 'features/stats/components/snaps/SnapItem';

const formatDate = (date) => (date ? new Date(date).toLocaleDateString() : '—');
const formatNumber = (number) => {
  if (number === null || number === undefined) return '—';
  return number.toLocaleString('ru-RU', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
};
const formatPercent = (number) => {
  if (number === null || number === undefined) return '—';
  return `${(number * 100).toFixed(2)}%`;
};

const SnapsList = (props) => {
  const filterOptions = [
    {
      key: 'date__gte',
      label: 'Дата (с)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'date__lte',
      label: 'Дата (по)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'store',
      label: 'Магазины',
      field: ({ value, onChange, className }) => (
        <ItemSelector
          targetUrl='/admin-api/stores'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите магазин'
          searchPlaceholder='Поиск магазина...'
          noItemsFoundText='Магазины не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.store ? [props.store] : [],
    },
    {
      key: 'product',
      label: 'Товары',
      field: ({ value, onChange, className }) => (
        <ItemSelector
          targetUrl='/products/admin-api/products'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите товар'
          searchPlaceholder='Поиск товара...'
          noItemsFoundText='Товары не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.product ? [props.product] : [],
    },
    {
      key: 'product__categories',
      label: 'Категории',
      field: ({ value, onChange, className }) => (
        <ItemSelector
          targetUrl='/products/admin-api/categories'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите категорию'
          searchPlaceholder='Поиск категории...'
          noItemsFoundText='Категории не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.categories ? [props.categories] : [],
    },
  ];

  const columns = [
    { key: 'id', label: 'ID', hide: true },
    { 
      key: 'date', 
      label: 'Дата', 
      component: (item) => <>{formatDate(item.date)}</> 
    },
    { 
      key: 'store', 
      label: 'Магазин', 
      component: (item) => <>{item.store?.meta?.name || item.store_name || '—'}</> 
    },
    { 
      key: 'product', 
      label: 'Товар', 
      component: (item) => <>{item.product?.meta?.name || item.product_name || '—'}</> 
    },
    { 
      key: 'price', 
      label: 'Цена', 
      component: (item) => <>{formatNumber(item.price)}</> 
    },
    { 
      key: 'cost', 
      label: 'Себестоимость', 
      component: (item) => <>{formatNumber(item.cost)}</> 
    },
    { 
      key: 'margin', 
      label: 'Маржа', 
      component: (item) => <>{formatPercent(item.margin)}</> 
    },
    { 
      key: 'qty_open', 
      label: 'Остаток (нач)', 
      component: (item) => <>{formatNumber(item.qty_open)}</> 
    },
    { 
      key: 'qty_close', 
      label: 'Остаток (кон)', 
      component: (item) => <>{formatNumber(item.qty_close)}</> 
    },
    { 
      key: 'sales_sum', 
      label: 'Сумма продаж', 
      component: (item) => <>{formatNumber(item.sales_sum)}</> 
    },
    { 
      key: 'sales_profit', 
      label: 'Прибыль', 
      component: (item) => <>{formatNumber(item.sales_profit)}</> 
    },
    { 
      key: 'created', 
      label: 'Создано', 
      component: (item) => <>{formatDate(item.created)}</> 
    },
    { 
      key: 'updated', 
      label: 'Обновлено', 
      component: (item) => <>{formatDate(item.updated)}</> 
    },
  ];

  return (
    <List
      targetUrl='/stats/admin-api/snaps'
      filterOptions={filterOptions}
      columns={columns}
      ItemComponent={SnapItem}
    />
  );
};

export default SnapsList;
